import React from "react";
import styled from "styled-components";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import {
  checkboxStyles,
  checkedStyles,
  uncheckedStyles,
} from "@sonder/ui/source/styled/fragments/Checkbox";

interface CheckboxIconProps {
  checked: boolean;
  onClick?: (event: React.MouseEvent) => void;
}

const StyledCheckbox = styled.span<CheckboxIconProps>`
  ${checkboxStyles}
  flex-shrink: 0;
  ${props => (props.checked ? checkedStyles : uncheckedStyles)}
`;

export const CheckboxIcon = (props: CheckboxIconProps) => {
  const { checked } = props;
  return (
    <StyledCheckbox {...props} data-testid={`checked:${checked}`}>
      {checked && <CheckBoxIcon />}
      {!checked && <CheckBoxOutlineBlankIcon />}
    </StyledCheckbox>
  );
};
